import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { EProductType, IIbanObject, MULTISTRATEGY_PRODUCTS } from '../../athora.constants';
import { ASSETS_TABLE_TABLE_KEYS } from '../../../shared/components/assets-table/assets-table.constants';
import { ADDITIONAL_PAYMENTS_ASSETS_TABLE_TABLE_KEYS, payment_form_keys } from './additional-payment.constants';
import { PolicyService } from 'src/app/modules/policy/policy.service';

@Component({
  selector: 'app-additional-payment',
  templateUrl: './additional-payment.component.html',
  styleUrl: './additional-payment.component.scss',
})
export class AdditionalPaymentComponent implements OnChanges, OnDestroy {

  @Input() form: FormGroup;
  @Input() ibanList: IIbanObject[] = [];
  @Input() assets: IPolicyAsset[];
  @Input() isReadOnly: boolean;
  keys: IFormKey[] = CommonUtils.assign(payment_form_keys);
  destroy$ = new Subject();

  constructor(
    private _policyService: PolicyService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ibanList'] && changes['ibanList'].currentValue) {
      this.populateIbanOptions();
    }
  }

  get showFunds(): boolean {
    return this.assets && this.assets.length > 0;
  }

  get isMultistrategyProduct(): boolean {
    return MULTISTRATEGY_PRODUCTS.includes(EProductType[this._policyService.productCode]);
  }

  get tableKeys(): ITableKey[] {
    return this.isMultistrategyProduct ?
      ASSETS_TABLE_TABLE_KEYS :
      ADDITIONAL_PAYMENTS_ASSETS_TABLE_TABLE_KEYS;
  }

  populateIbanOptions(): void {
    this.keys = CommonUtils.populateIbanOptions(this.keys, this.ibanList);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
